type ListingFeature = {translation: string; isHighlighted: boolean};

const TITLE_HIGHLIGHTS = 3;

// Prototype v11: the vehicle title and the first 3 highlighted features.
export function equipmentTitle(title: string, features: ListingFeature[]) {
  const highlights = features
    .filter(({isHighlighted}) => isHighlighted)
    .slice(0, TITLE_HIGHLIGHTS)
    .map(({translation}) => translation);
  return [title, ...highlights].join(' · ');
}
